export const BLACKLIST = {
  FORMS: ['LOOT_GRAB'],
};
